export default {
    methods: {
      replaceByDefault(e) {
        e.target.src = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRwvW8zq-KtqC7Uds4qZF6oOKVRbYFoLUKWqiqLJO-ujXJE0AWyKvMPs1TlxqOaVoHonmg&usqp=CAU';
      },
    },
  };